import { call, put, takeLatest } from "redux-saga/effects";
import request from "utils/request";
import { editCreatorActions } from "./index";
import { showToast } from "components/ToastContainer/index";

// ======================
// GET BY ID
// ======================
function* getCreatorById(action) {
  try {
    const { creatorId } = action.payload;

    const response = yield call(
      request,
      `/api/get-creators/getCreatorsById?id=${creatorId}`,
      {
        method: "GET",
        credentials: "include"
      }
    );

    yield put(editCreatorActions.getCreatorByIdSuccess(response.data));
  } catch (error) {
    yield put(editCreatorActions.getCreatorByIdFailure(error.message));
  }
}

// ======================
// UPDATE
// ======================
function* updateCreator(action) {
  try {
    const { id, payload } = action.payload;
    yield call(request, `/api/creators/${id}`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
      credentials: "include"
    });

    yield put(editCreatorActions.updateCreatorSuccess());
  } catch (error) {
    yield put(editCreatorActions.updateCreatorFailure(error.message));
    showToast(error.message || "Failed to update creator", "danger");
  }
}

export function* editCreatorSaga() {
  yield takeLatest(editCreatorActions.getCreatorById.type, getCreatorById);
  yield takeLatest(editCreatorActions.updateCreator.type, updateCreator);
}
